import { render, staticRenderFns } from "./GenericSelector.vue?vue&type=template&id=28b4f5a0&"
import script from "./GenericSelector.vue?vue&type=script&lang=js&"
export * from "./GenericSelector.vue?vue&type=script&lang=js&"
import style0 from "./GenericSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports